import { TURNTO_SITE_KEY } from '@/services/Configuration'
import Script from 'next/script'
import { log } from '@/services/Log'

const TurnToScript: React.FC = () => (
  <>
    <Script
      type="text/javascript"
      strategy="afterInteractive"
      onLoad={() => {
        log('TurnTo script loaded')
      }}
      src={`https://widgets.turnto.com/v5/widgets/${TURNTO_SITE_KEY}/js/turnto.js`}
    />
  </>
)

export default TurnToScript
